// extracted by mini-css-extract-plugin
export default {"statusFinished":"e3PaqNrrmwMn06RoblHl","statusRefunded":"X62nZ4Y2zI9BQsmvYCZG","statusStopped":"FGdp6QATjbKWIuQ2aq0w","refundStatus":"VNSiNiHXCQLJDKDkp4Tu"};